module.exports = __webpack_public_path__ + "static/media/bg9.c3a398cf.jpg";